import React__default from 'react';
import { MiniArticleListNewsArticle } from './mini-article-list-news-article.esm.js';

//TODO: FAISAL: CHANGED
//import { Divider } from '@costar-ui/components' // BREAKS BIMMO!
var MiniArticleListNewsList = function MiniArticleListNewsList(props) {
  var articles = props.articles;
  var listItems = articles.map(function (article, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: index
    }, /*#__PURE__*/React__default.createElement(MiniArticleListNewsArticle, {
      article: article
    }), /*#__PURE__*/React__default.createElement("hr", {
      className: "border-neutral/50"
    }));
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "px-4"
  }, /*#__PURE__*/React__default.createElement("ul", null, listItems));
};

export { MiniArticleListNewsList };
//# sourceMappingURL=mini-article-list-news-list.esm.js.map
